@if (hasAccessToAISummary$ | async) {
  <div class="ai-summary-gradient-border-wrap">
    <mat-expansion-panel
      [expanded]="openAISummaryExpansionPanel()"
      (expandedChange)="onExpandedChange($event)"
      class="ai-summary-gradient-border"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon svgIcon="galaxy-ai-icon" class="aiIcon" />
          {{ 'AI_SUMMARY.TITLE' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        @if (aiSummaryResponse$ | async; as aiSummaryResponse) {
          @if (aiSummaryIsLoading()) {
            <glxy-loading-spinner />
          } @else if (noAISummary()) {
            <glxy-alert type="tip">
              {{ aiSummaryResponse }}
            </glxy-alert>
          } @else {
            <p [innerHTML]="aiSummaryResponse"></p>
            <button mat-stroked-button class="regenerateAISummaryButton" (click)="regenerateSummary(true)">
              {{ 'AI_SUMMARY.REGENERATE_SUMMARY' | translate }}
            </button>
          }
        } @else {
          <glxy-loading-spinner />
        }
      </ng-template>
    </mat-expansion-panel>
  </div>
} @else if (showAISummaryRestrictedDialog()) {
  <div class="ai-summary-gradient-border-wrap">
    <mat-expansion-panel [disabled]="true" class="ai-summary-gradient-border">
      <mat-expansion-panel-header (click)="onOpenNoFeatureAISummary()">
        <mat-panel-title>
          <mat-icon svgIcon="galaxy-ai-icon" class="aiIcon" />
          {{ 'AI_SUMMARY.TITLE' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
  </div>
}
